import React from "react";
import { Container, Row, Col } from "reactstrap";
import {
  DiJavascript,
  DiReact,
  DiDatabase,
  DiPhp,
  DiPostgresql,
} from "react-icons/di";
import { FaAws } from "react-icons/fa";
import { GrDocker, GrHeroku } from "react-icons/gr";
import { SiTypescript, SiAmazonaws, SiBootstrap } from "react-icons/si";

const CarouselSkills = () => {
  return (
    <section id="integration" className="section integrations">
      <Container style={{ marginTop: "6em" }}>
        <Row className="justify-content-center text-center">
          <Col lg={12} md={12} sm={12}>
            <div className="slider">
              <div className="slide-track">
                <div className="slide">
                  <i>
                    <iconDiJavascript className="IconSkills" />
                  </i>
                </div>
                <div className="slide">
                  <i>
                    <DiReact className="IconSkills" />
                  </i>
                </div>
                <div className="slide">
                  <i>
                    <GrDocker className="IconSkills" />
                  </i>
                </div>
                <div className="slide">
                  <i>
                    <GrHeroku className="IconSkills" />
                  </i>
                </div>
                <div className="slide">
                  <i>
                    <DiDatabase className="IconSkills" />
                  </i>
                </div>
                <div className="slide">
                  <i>
                    <DiPhp className="IconSkills" />
                  </i>
                </div>
                <div className="slide">
                  <i>
                    <DiPostgresql className="IconSkills" />
                  </i>
                </div>
                <div className="slide">
                  <i>
                    <SiAmazonaws className="IconSkills" />
                  </i>
                </div>
                <div className="slide">
                  <i>
                    <SiBootstrap className="IconSkills" />
                  </i>
                </div>
                <div className="slide">
                  <i>
                    <SiTypescript className="IconSkills" />
                  </i>
                </div>
                <div className="slide">
                  <i>
                    <FaAws className="IconSkills" />
                  </i>
                </div>
                <div className="slide">
                  <i>
                    <DiJavascript className="IconSkills" />
                  </i>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CarouselSkills;
